import { useState, useEffect } from "react";
import { answeredLessonMultipleChoiceQuestion } from '../../../api/lesson_modules/students';

function MultiChoiceWidget(props) {
  const [_, setAnswers] = useState(props.answers);
  const userSubmittedAnswer = Object.keys(props.user_selected_answer).length !== 0;
  const [answer, setAnswer] = useState(userSubmittedAnswer && parseInt(props.user_selected_answer.answer));
  useEffect(() => {
    setAnswers(props.answers);
  }, [answer])


  async function onAddAnswer(event) {
    const val = parseInt(event.target.value);
    setAnswer(parseInt(event.target.value));
    await onSubmitAnswer(val);
  }

  async function onSubmitAnswer(val) {
    const lessonId = props.lesson_id;
    const lessonTriggerModuleId = props.id;
    const body = {
      id: lessonId,
      lesson_module_multiple_choice_answer: {
        answer: val,
        lesson_multiple_choice_question_module_id: lessonTriggerModuleId,
      }
    };
    await addAnswer(body);
  }

  async function addAnswer(body) {
    try {
      await answeredLessonMultipleChoiceQuestion(body);
    } catch (err) {
      console.log(err);
      // TODO: what do we do if an error occurs reaching the server?
    }
  }

  return (
    <div className="EmployeeReaderWidget EmployeeReaderMultiChoiceWidget">
      {/* <h1>Multiple choice</h1> */}
      <div className="EmployeeReaderMultiChoiceWidgetQuestionContainer">
        <div className="EmployeeReaderMultiChoiceWidgetQuestion">
          {props.question || "Question not avaiable"}
        </div>
        <div className="EmployeeReaderMultiChoiceWidgetAnswers">
          {props.answers.map(({name, value}, idx) => {
            if (value.length === 0) {
              return
            }
            return (
              <div className="EmployeeReaderMultiChoiceWidgetAnswer" key={idx}>
                <input
                  type="radio" 
                  name={`${props.lesson_module_name}${props.id}`}
                  value={idx} 
                  onChange={onAddAnswer}
                  checked={idx === answer}
                />
                <label htmlFor={name}>{value}</label><br />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export { MultiChoiceWidget }
